import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton, Textfield, Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { TruncatedText } from "app/pages/sales-intelligence/common-components/TruncatedText";

export const StyledEditableChipItemWrapper = styled(Flex)`
    max-width: 100%;
`;

export const StyledListItemWrapper = styled(StyledEditableChipItemWrapper)`
    margin-top: 4px;
`;

export const StyledSelectableChipItem = styled(StyledEditableChipItemWrapper)<{ isSelected?: boolean }>`
    padding: 7px;
    height: 32px;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
    color: ${({ isSelected }) => (isSelected ? colorsPalettes.blue[400] : colorsPalettes.midnight[200])};

    border-radius: 6px;
    border: 1px solid ${({ isSelected }) => (isSelected ? colorsPalettes.blue[400] : colorsPalettes.carbon[50])};
    background: ${({ isSelected }) => (isSelected ? colorsPalettes.bluegrey[100] : colorsPalettes.carbon[0])};

    &:hover {
        color: ${colorsPalettes.blue[400]};
        background: ${({ isSelected }) => (isSelected ? colorsPalettes.blue[100] : colorsPalettes.bluegrey[100])};
    }

    ${SWReactIcons} {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 16px;
        height: 16px;

        & svg {
            width: 9px;
            height: 9px;

            path {
                fill: ${colorsPalettes.blue[400]};
            }
        }
    }
`;

export const StyledEditableChipInputContainer = styled.div`
    .input-container {
        width: 200px;
        height: 40px;
    }

    .Button {
        min-width: 60px;
    }
`;

export const StyledEditableChipCloseButton = styled(IconButton)`
    ${SWReactIcons} {
        width: 10px;
        height: 10px;

        & svg {
            width: 10px;
            height: 10px;
        }
    }
`;

export const StyledAddNewChipButton = styled(IconButton)`
    ${SWReactIcons} {
        width: 16px;
        height: 16px;

        & svg {
            width: 16px;
            height: 16px;

            path {
                fill: ${colorsPalettes.blue[400]};
            }
        }
    }
`;

export const StyledAddNewChipTextfield = styled(Textfield)`
    .input-container {
        padding: 0 8px 0 15px;
    }
`;

export const StyledChipTooltip = styled(Tooltip)`
    overflow-wrap: break-word;
`;

export const StyledChipTruncatedText = styled(TruncatedText)`
    cursor: pointer;
    user-select: none;
`;
